/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Field_MotivationInputs */

const en_us2_search_field_motivation = /** @type {(inputs: Search_Field_MotivationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motivation`)
};

const pt_br2_search_field_motivation = /** @type {(inputs: Search_Field_MotivationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motivação`)
};

const es_419_search_field_motivation = /** @type {(inputs: Search_Field_MotivationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motivación`)
};

const pt_pt2_search_field_motivation = /** @type {(inputs: Search_Field_MotivationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motivação`)
};

const fr_fr2_search_field_motivation = /** @type {(inputs: Search_Field_MotivationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motivation`)
};

const de_de2_search_field_motivation = /** @type {(inputs: Search_Field_MotivationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motivation`)
};

const it_it2_search_field_motivation = /** @type {(inputs: Search_Field_MotivationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motivazione`)
};

/**
* | output |
* | --- |
* | "Motivation" |
*
* @param {Search_Field_MotivationInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_field_motivation = /** @type {((inputs?: Search_Field_MotivationInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Field_MotivationInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_field_motivation(inputs)
	if (locale === "es-419") return es_419_search_field_motivation(inputs)
	if (locale === "pt-PT") return pt_pt2_search_field_motivation(inputs)
	if (locale === "fr-FR") return fr_fr2_search_field_motivation(inputs)
	if (locale === "de-DE") return de_de2_search_field_motivation(inputs)
	if (locale === "it-IT") return it_it2_search_field_motivation(inputs)
	return en_us2_search_field_motivation(inputs)
});
export { search_field_motivation as "search.field_motivation" }